import Swiper from 'swiper/dist/js/swiper';




;(function (d, $) {
    $(function () {
 
       /**
        * Add referential and support body classes
        */
       new Swiper("#slider__guides", {

        spaceBetween: 80,
        slidesPerView: 2,
        slidesPerGroup:2,
        speed : 3000 ,
        preventClicks: false,
        preventClicksPropagation: false,
        preloadImages: false,
        autoplay: {
            delay: 6500
         },
        lazy: {
            preloaderClass: 'spinner-loading',
        },
        loop: false,
        allowTouchMove: true,
        navigation: {      
            nextEl: ".swiper__guide-btn-next ",
            prevEl: ".swiper__guide-btn-prev "
        },
        observer: true ,
        breakpoints: {
          
            768: {
            
              spaceBetween: 5,
            }
      
          }
     
    
    });

    $('.btn_grid').on('click' , function(){
        console.log("click")
        $(this).toggleClass("active");
        $('.hidden_item').toggleClass("display")
    })
 
    })
 
 })(document, jQuery);